module.exports = __webpack_public_path__ + "static/media/skill-hat.410760e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CourseDetail/skill-hat.svg
// module id = 125
// module chunks = 0